// src/api/tenantService.js
import apiClient from './apiClient';

// Tenant service
const tenantService = {
  // Get all tenants
  getAllTenants: async () => {
    const response = await apiClient.get('/tenants');
    return response.data;
  },

  // Get tenant by ID
  getTenantById: async (id) => {
    const response = await apiClient.get(`/tenants/${id}`);
    return response.data;
  },

  // Create a new tenant
  createTenant: async (tenantData) => {
    // Set default values for new tenants
    const newTenant = {
      ...tenantData,
      total_services: 0,
      total_connectors: 0,
      total_interactions: 0,
      tenant_since: new Date().toISOString(),
    };
    
    const response = await apiClient.post('/tenants', newTenant);
    return response.data;
  },

  // Update an existing tenant
  updateTenant: async (id, tenantData) => {
    const response = await apiClient.put(`/tenants/${id}`, tenantData);
    return response.data;
  },

  // Delete a tenant
  deleteTenant: async (id) => {
    const response = await apiClient.delete(`/tenants/${id}`);
    return response.data;
  },
};

export default tenantService;